/**
 * Global rulles for URLLoader and Loader instances, applyed before local rulles
 */
export var globalRedirectRules = [];
export function matchRedirect(url, rules) {
    var rule = undefined;
    var all = rules ? globalRedirectRules.concat(rules) : globalRedirectRules;
    all.forEach(function (_a) {
        var test = _a.test, resolve = _a.resolve, _b = _a.supressErrors, supressErrors = _b === void 0 ? false : _b, _c = _a.supressLoad, supressLoad = _c === void 0 ? false : _c;
        var passed = false;
        if (typeof test === 'function') {
            passed = test(url);
        }
        else if (test instanceof RegExp) {
            passed = test.test(url);
        }
        else if (typeof test === 'string') {
            passed = test === url;
        }
        if (passed) {
            if (rule) {
                console.warn('[LOADER] Duplicate redirect rules, latest rule would be used!');
            }
            rule = {
                url: url,
                supressErrors: supressErrors, supressLoad: supressLoad
            };
            if (typeof resolve === 'function') {
                rule.url = resolve(url);
            }
            else if (resolve instanceof RegExp) {
                rule.url = url.match(resolve)[0];
            }
            else if (typeof resolve === 'string') {
                rule.url = resolve;
            }
            else if (typeof passed === 'string') {
                rule.url = passed;
            }
            if (typeof rule.url === 'undefined') {
                console.warn('[LOADER] Redirect url is null, would be used  original url!');
                rule.url = url;
            }
        }
    });
    return rule;
}
